/**
 * Reusable continue block: green bar with message lines and a continue button (arrow in circle).
 * Used after document submission summary and other steps.
 */
import React from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import continueIcon from '../../../../assests/icons/continue.png';
import './ContinueBlock.css';

export interface ContinueBlockProps {
  /** First line of message (e.g. "初めの手続きが完了しました。") */
  line1: string;
  /** Optional second line (e.g. "続いて、登録の次の段階へ進んでください。") */
  line2?: string;
  /** Button label; defaults to translation of submitDocuments.chat.continue */
  buttonLabel?: string;
  onContinue: () => void;
}

const ContinueBlock: React.FC<ContinueBlockProps> = ({
  line1,
  line2,
  buttonLabel,
  onContinue,
}) => {
  const { t } = useLanguage();
  const label = buttonLabel ?? t('submitDocuments.chat.continue');

  return (
    <div className="continue-block">
      <div className="continue-block__message">
        <p className="continue-block__line1">{line1}</p>
        {line2 && <p className="continue-block__line2">{line2}</p>}
      </div>
      <button
        type="button"
        className="continue-block__btn"
        onClick={onContinue}
        aria-label={label}
      >
        <span className="continue-block__btn-arrow-wrap" aria-hidden>
          <img src={continueIcon} alt="" className="continue-block__btn-arrow" />
        </span>
      </button>
    </div>
  );
};

export default ContinueBlock;
